import React, { Component } from 'react';
import { Form, Grid } from 'semantic-ui-react';
import { Field, reduxForm } from 'redux-form';

import { InputField } from 'Common/SemanticWrapper';
import { VENDING_MACHINE_ENTRY_FORM_NAME } from 'Common/FormEnum';
import { VendingMachineFieldEnum } from 'Common/FieldEnum';
import { StyledReduxFormError } from 'Components/';
import { SiteComponent } from 'Common/SiteComponent';

class VendingMachineEntryFormContainer extends Component {
  render() {
    const { error } = this.props;

    return (
      <Form>
        <Grid columns={3}>
          <Field
            name={VendingMachineFieldEnum.Id}
            component="input"
            type="hidden"
          />

          <Grid.Row>
            <Grid.Column>
              <Field
                type="text"
                name={VendingMachineFieldEnum.Name}
                component={InputField}
                label="Name"
                maxLength={7}
              />
            </Grid.Column>

            <Grid.Column>
              <Field
                type="text"
                name={VendingMachineFieldEnum.Description}
                component={InputField}
                label="Description"
                maxLength={50}
              />
            </Grid.Column>

            <Grid.Column>
              <SiteComponent
                isForm={true}
                name={VendingMachineFieldEnum.SiteId}
                isAllRequired={false}
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column>
              <StyledReduxFormError error={error} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!values[VendingMachineFieldEnum.Name]) {
    errors[VendingMachineFieldEnum.Name] = 'Name is required';
  } else if (values[VendingMachineFieldEnum.Name].indexOf(' ') > -1) {
    errors[VendingMachineFieldEnum.Name] = 'Name must not contain spaces';
  }

  if (!values[VendingMachineFieldEnum.Description]) {
    errors[VendingMachineFieldEnum.Description] = 'Description is required';
  }

  if (!values[VendingMachineFieldEnum.SiteId]) {
    errors[VendingMachineFieldEnum.SiteId] = 'Site ID is required';
  }

  return errors;
};

export const VendingMachineEntryForm = reduxForm({
  form: VENDING_MACHINE_ENTRY_FORM_NAME,
  validate,
})(VendingMachineEntryFormContainer);



// WEBPACK FOOTER //
// ./src/pages/vendingsetup/components/VendingMachineEntryForm.js